import classes from './PreferenceBanner.scss';

const sceBanner = (props) => {
  let heroImg=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Illustration.svg';
  return (
    <div className={classes.sceFormBanner}>
      <div className={classes.sceBannerMessageContainer}>
        <div className={classes.sceBannerMessage}>
        <p><img className={classes.imgBlock} src={heroImg} alt="Block Image" /></p>
          <div className={classes.sceSingleStatement}>
            {props.message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default sceBanner;